import { DisplayDecorator } from '../decorators/display-decorator';
import { TextModel } from '../models/primitive/text.model';

const GID_SLICE_LENGTH = -8;

export function sortByGid(
    entries: Array<DisplayDecorator<TextModel>>,
    userGid: string,
): Array<DisplayDecorator<TextModel>> {
    return entries.sort((data) => (data.displayName.slice(GID_SLICE_LENGTH) === userGid ? -1 : 0));
}
